import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { Label, Toaster } from "@fluentui/react-components";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getLiabilityDetailById,
  getLiabilityPaymentDetailById,
  getLiabilityPaymentsCommissionDetailById,
  getLiabilityPaymentsCommissionsListItems,
} from "../../../../redux/Case/liabilitySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function LiabilityPaymentCommission({ tab }: { tab?: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();

  const { clientId, case_type, action, caseId, subItemId, subSubItemId } =
    useParams();
  const dispatch: AppDispatch = useDispatch();
  const liabilities = useSelector((state: RootState) => state.liabilities);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const caseType = case_type || "";
  const [activeTab, setActiveTab] = useState<string>(tab || "commission");
  const [isOpen, setIsOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(1);

  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId && subItemId) {
      dispatch(getLiabilityDetailById({ id: caseId, customerId: clientId }));
      dispatch(getLiabilityPaymentDetailById(subItemId));
      dispatch(
        getLiabilityPaymentsCommissionsListItems({
          paymentId: subItemId,
          caseId,
          customerId: clientId,
        }),
      );
    }
  }, [caseId, clientId, subItemId, dispatch, liabilities.payments.listItems]);

  useEffect(() => {
    if (subItemId && liabilities.payments.listItems?.length > 0) {
      dispatch(getLiabilityPaymentDetailById(subItemId));
    }
  }, [subItemId, activeTab, liabilities.payments.listItems, dispatch]);

  useEffect(() => {
    if (
      subSubItemId &&
      liabilities.payments.commissions.listItems?.length > 0
    ) {
      dispatch(getLiabilityPaymentsCommissionDetailById(subSubItemId));
    }
  }, [
    subSubItemId,
    activeTab,
    liabilities.payments.commissions.listItems,
    dispatch,
  ]);

  const paymentId =
    subItemId || liabilities.payments.listItems?.[0]?.payment?.payment_id;
  const commissionId =
    subSubItemId ||
    liabilities.payments?.commissions?.listItems[0]?.commission_id;

  useEffect(() => {
    if (!caseId || !paymentId || !commissionId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`,
      );
    } else if (action === "add") {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/commission/add`,
      );
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/edit`,
      );
    } else {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`,
      );
    }
  }, [
    action,
    clientId,
    case_type,
    tab,
    caseId,
    paymentId,
    commissionId,
    liabilities.payments.commissions.listItems,
    navigate,
  ]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="liabilities"
        tab={activeTab}
        caseType={caseType}
        caseDetail={liabilities.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="liabilities"
          caseType={caseType}
          caseDetail={liabilities.payments.commissions.activeItem}
          caseItemList={liabilities.payments.commissions.listItems}
          tab={activeTab}
          subItem="payments"
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {liabilities?.payments.commissions.loading ? (
            <ContentLoader />
          ) : (
            <>
              {liabilities?.payments.commissions.listItems.length > 0 && (
                <CaseList
                  module="commission"
                  data={liabilities?.payments.commissions.listItems}
                  activeItem={liabilities?.payments.commissions.activeItem}
                  section="liabilities"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action &&
                liabilities?.payments.commissions.listItems.length === 0 && (
                  <NoDataFound />
                )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={liabilities?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default LiabilityPaymentCommission;
